'use client'

import { useEffect } from 'react'

import { getClientEnv } from '@/env/client'

export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    useEffect(() => {
        const { logger } = getClientEnv()
        logger
            .withError(error)
            .withMetadata({ digest: error.digest, boundary: 'global' })
            .error('Unhandled global error')
    }, [error])

    return (
        <html>
            <body>
                <div className="container flex max-w-sm flex-col items-center py-15 text-center">
                    <h1 className="pb-4 text-xl font-bold">Something went wrong</h1>
                    <p className="pb-6">
                        An unexpected error occurred while loading the application. Try again or
                        return to the homepage.
                    </p>
                    <button
                        onClick={reset}
                        className="rounded-md bg-[#087484] px-6 py-2 text-sm font-medium text-white hover:bg-[#065e6a]"
                    >
                        Try again
                    </button>
                </div>
            </body>
        </html>
    )
}
